module.exports = __webpack_public_path__ + "media/images/premium/premium_ui_tw_03-900-4f9cd082ad33013bb9c5235c002fa5be.png";